export default {
  setFinanciamentos({ commit }, payload) {
    commit("setFinanciamentos", payload)
  }
}
